<template>
  <div class="article">
    <div class="article-list">
      <div class="article-title" v-if="articleContent.title">
        {{ articleContent.title }}
      </div>
      <div class="article-sm-title">
        <div class="author-time">
          <p>
            <b>{{ articleContent.editor }}</b>
            · {{ articleContent.time }} 丨
          </p>
        </div>
        <div class="article-column">{{ articleContent.aColumn }}</div>
      </div>
      <div class="subtitle">
        <b>{{ articleContent.subtitle }}</b>
      </div>
      <div class="HR">
        <hr style="border: 1px solid #4b4747" />
      </div>
      <div class="vid">
        <video
          v-if="articleContent.imgUrl"
          controls
          style="width: 100%; height: 100%"
        >
          <source v-lazy="articleContent.imgUrl" type="video/mp4" />
          你的浏览器不支持video标签
        </video>
      </div>
      <div class="article-content" v-html="articleContent.content"></div>
      <div v-if="articleContent.imgUrl2">
        <el-link :href="articleContent.imgUrl2" download
          >下载附件:{{ articleContent.imgUrlName }}</el-link
        >
      </div>
    </div>
    <div class="nf-column">
      <div class="nf-column-name">
        <p>最新文章</p>
      </div>
      <div class="nf-column-list">
        <div
          class="nf-column-list-ul"
          v-for="(i, index) in articleList"
          :key="index"
        >
          <div class="nf-column-list-ul-img" @click="getNumber(i.number)">
            <router-link
              class="h1title"
              :to="{ path: '/index/article', query: { id: i.number } }"
              style="text-decoration: none; color: black"
            >
              <img v-lazy="i.src" alt />
            </router-link>
          </div>
          <div class="nf-colum-list-content">
            <h1 @click="getNumber(i.number)" style="cursor: pointer">
              <router-link
                class="h1title"
                :to="{ path: '/index/article', query: { id: i.number } }"
                style="text-decoration: none; color: black"
                >{{ i.title }}</router-link
              >
            </h1>
            <div class="nf-colum-list-content-mid">
              <p style="font-weight: 200">{{ i.subtitle }}</p>
            </div>
            <div class="nf-colum-list-content-bottom">
              <div>
                <p>
                  类型：
                  <b>{{ i.aColumn }}</b>
                </p>
              </div>
              <div class="content-time">
                <p style="font-weight: 200">
                  <i class="el-icon-time"></i>
                  {{ i.time }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="text-align: center">
        <el-button @click="addArticle()">查看更多资讯</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      titleName: "",
      limit: this.$store.state.limit, //循环次数
      articleNnmber: this.$route.query.id, //文章编号
      articleContent: {
        title: "",
        editor: "",
        time: "",
        aColumn: "",
        subtitle: "",
        content: "",
        imgUrl: "",
        imgUrl2: "",
        imgUrlName: "",
      },
      articleList: [],
    };
  },
  watch: {
    loopNum: {
      handler() {
        if (document.body.clientWidth > 678) {
          this.loopNum = 3;
        } else {
          this.loopNum = 6;
        }
      },
      immediate: true,
    },
    articleNnmber: {
      handler() {
        if (this.articleNnmber == 0) {
          return;
        }
        this.getArtByNumber();
        window.scrollTo(0, 0);
        this.articleNnmber = "";
      },
      immediate: true,
    },
    "$store.state.artrcleNumber": {
      handler() {
        if (this.$store.state.artrcleNumber != 0) {
          this.articleNnmber = this.$store.state.artrcleNumber;
          this.$store.state.artrcleNumber = 0;
        }
      },
      immediate: true,
    },
  },
  methods: {
    //根据文章id获取文章内容
    async getArtByNumber() {
      if (this.articleNnmber != "") {
        const Res = await this.post("/website/getArtByNumber", {
          number: this.articleNnmber,
        }).catch((err) => {
          console.log(err);
        });
        (this.articleContent.title = Res.data.title),
          (this.articleContent.editor = Res.data.editor),
          (this.articleContent.time = this.handleDate(Res.data.createTime)),
          (this.articleContent.aColumn = Res.data.aColumn),
          (this.articleContent.subtitle = Res.data.subtitle),
          (this.articleContent.content = Res.data.content),
          (this.articleContent.imgUrl = Res.data.imgUrl);
        this.articleContent.imgUrl1 = Res.data.imgUrl1;
        this.articleContent.url = window.location.href;
        this.activated(this.articleContent);
        if (Res.data.imgUrl2 != null) {
          this.articleContent.imgUrl2 =
            "http://admin.gdfdc.com:8081/upload/download/" + Res.data.id;
          this.articleContent.imgUrlName = Res.data.name;
        } else {
          this.articleContent.imgUrl2 = "";
        }
      }
    },
    //最新文章
    async getNews() {
      const Res = await this.post("/website/getNews", {
        city: this.$store.state.city,
        limit: this.loopNum,
      }).catch((err) => {
        console.log(err);
      });
      let tempData = [];
      for (var i in Res.data) {
        tempData.push({
          title: Res.data[i].title,
          subtitle: Res.data[i].subtitle,
          aColumn: Res.data[i].aColumn,
          time: this.handleDate(Res.data[i].createTime),
          number: Res.data[i].number,
          src: Res.data[i].imgUrl1,
        });
      }
      this.articleList = tempData;
    },
    //获取文章id
    getNumber(e) {
      this.articleNnmber = e;
    },
    addArticle() {
      this.$router.push({ path: "/index/whole", name: "whole" });
      window.scrollTo(0, 0);
    },
    //微信自定义分享链接
    activated(e) {
      this.$wxShare.updateWxShareConfig({
        title: e.title,
        desc: e.subtitle,
        imgUrl: e.imgUrl1,
        link: e.url,
      });
    },
  },
  mounted() {},
  created() {
    window.scrollTo(0, 0);
    // this.getArtByNumber();
    this.getNews();
  },
};
</script>

<style lang="scss" scoped>
.article {
  width: 100%;
  padding: 0 3% 0 3%;
}
.article-list {
  width: 100%;
}
.article-title {
  font-size: 30px;
  font-weight: bold;
  letter-spacing: 3px;
  width: 100%;
  margin: 30px 0 30px 0;
  background-color: #f7f7f7;
}
.article-sm-title {
  display: flex;
  margin: 10px 0 10px 0;
  box-sizing: border-box;
}
.author-time {
  font-size: 25px;
  padding: 8px 8px 8px 0;
  p {
    font-weight: 200;
  }
  b {
    color: #2a82e4;
  }
}
.subtitle {
  margin: 50px 0 0 0;
  font-size: 22px;
  color: rgba($color: #000000, $alpha: 0.35);
}
.HR {
  margin: 50px 0 0 0;
  width: 20%;
  height: 50px;
}
.article-content {
  margin: 0 0 100px 0;
}
.article-content {
  /deep/ img {
    width: 100%;
  }
  /deep/ pre {
    white-space: pre-wrap;
    word-wrap: break-word;
  }
}
.article-column {
  background-color: #2a82e4;
  color: white;
  font-size: 15px;
  width: 100px;
  text-align: center;
  padding: 5px 8px 0 8px;
  margin: 10px 0 0 0;
  box-sizing: border-box;
  height: 30px;
}
.nf-column {
  width: 100%;
  box-sizing: border-box;
}
.nf-column-name {
  font-size: 30px;
  font-weight: 600;
  margin: 40px 0 10px 30px;
}
/deep/.el-button {
  width: 250px;
  border: #000 solid 1px;
}

.nf-column-list-ul {
  display: flex;
  height: 204px;
  margin: 20px 25px 0 25px;
}
.nf-column-list-ul-img {
  width: 400px;
  height: 130px;
  img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
  }
}
.nf-colum-list-content {
  margin: 0px 0 0 25px;
  height: 130px;
  position: relative;
  width: 100%;
  h1 {
    font-size: 20px;
    font-weight: 400;
  }
  p {
    font-size: 15px;
    font-weight: 400;
  }
  .nf-colum-list-content-mid {
    position: absolute;
    bottom: 35px;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
  }
  .nf-colum-list-content-bottom {
    display: flex;
    justify-content: space-between;
    position: absolute;
    bottom: 0px;
    width: 100%;
    p {
      color: rgba($color: #000000, $alpha: 0.7);
    }
    b {
      color: rgba(11, 104, 192, 0.7);
    }
  }
  .content-time {
    float: right;
  }
}
@media (max-width: 768px) {
  .article-title {
    font-size: 25px;
    margin: 30px 0 20px 0;
  }
  .author-time {
    font-size: 16px;
    padding: 8px 8px 8px 0;
    p {
      font-weight: 200;
    }
    b {
      color: rgba(42, 130, 228, 1);
    }
  }
  .article-column {
    height: 25px;
    font-size: 15px;
    margin: 7px 0 0 0;
    padding: 3px 0 0 0;
    background-color: rgba(42, 130, 228, 1);
  }
  .subtitle {
    margin: 15px 0 0 0;
    font-size: 15px;
  }
  .nf-column {
    height: 800px;
  }
  .nf-column-name {
    font-size: 20px;
    margin: 40px 0 10px 10px;
  }
  .nf-column-list {
    border: none;
  }
  .nf-column-list-ul {
    height: 120px;
    display: flex;
    margin: 0 0 0 0;
  }
  .nf-column-list-ul-img {
    width: 240px;
    height: 90px;
  }
  .nf-colum-list-content {
    margin: 0 0 0 25px;
    height: 90px;
    h1 {
      font-size: 12px;
    }
    p {
      font-size: 10px;
      height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical; /* 垂直排列 */
      word-break: break-all;
    }
    .nf-colum-list-content-mid {
      bottom: 25px;
    }
  }
}
</style>